import {
  SCHEDULEDATES_DATA,
  FETCH_SCHEDULES_DATA_FULFILLED,
  SELECT_SCHEDULE_DATE,
  FETCH_SCHEDULES_TRACKS_DATA,
  FETCH_TRACK_SESSIONS_DATA,
  SHOW_SIDEBAR,
  SHOW_BACK_SCREEN,
  OPEN_QA_MODAL,
  FETCH_SESSION_LIVEQA_DATA,
  SESSION_POLL_LIST,
  SESSION_POLL_LIST_MODAL,
  SESSION_POLL_ACTION_MODAL,
  SESSION_POLL_RESULT,
  MY_BOOKED_SCHEDULE,
  MY_RATED_SESSION,
  HOLD_THIS_SESSION_DETAILS,
  FETCH_LIVEQA_REPLY,
  SELECT_SCHEDULE_TRACK,
  SET_SELECTED_SCHEDULE_DETAILS,
  SESSION_VIDEO_MODAL_DETAILS,
  THIS_SESSION_RATING_FORM,
  SESSION_POLL_NOT_SUBMITTED,
  SESSION_BY_TAG_FILTERED,
  SESSION_COLORS,
  ALL_EVENT_TRACKS,
  SESSION_FILTER_DATA,
  SESSION_FILTER_LIST,
  SESSIONS_FOR_ALL_TRACKS
} from '../actions';

export const SchedulesDataReducers = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SCHEDULES_DATA_FULFILLED:
      return action.payload;
    default:
      return state;
  }
};

export const SelectedScheduleDateReducer = (state = {}, action) => {
  switch (action.type) {
    case SELECT_SCHEDULE_DATE:
      return action.payload;
    default:
      return state;
  }
};

export const scheduleTracksDataReducer = (state = {}, action) => {
  if (action.type === FETCH_SCHEDULES_TRACKS_DATA) {
    return action.payload;
  }
  return state;
};

export const SelectedScheduleTrackReducer = (state = {}, action) => {
  if (action.type == SELECT_SCHEDULE_TRACK) {
    return action.payload;
  }
  return state;
};

export const sessionDetailsReducer = (state = '', action) => {
  if (action.type == SET_SELECTED_SCHEDULE_DETAILS) {
    return action.payload;
  }
  return state;
};

export const trackSessionsDataReducer = (state = {}, action) => {
  if (action.type === FETCH_TRACK_SESSIONS_DATA) {
    return action.payload;
  }
  return state;
};

export const showSidebarReducer = (state = {}, action) => {
  if (action.type === SHOW_SIDEBAR) {
    return action.payload;
  }
  return state;
};

export const showBackScreenReducer = (state = false, action) => {
  if (action.type === SHOW_BACK_SCREEN) {
    return action.payload;
  }
  return state;
};

export const sessionQADataReducer = (state = {}, action) => {
  if (action.type === FETCH_SESSION_LIVEQA_DATA) {
    return action.payload;
  }
  return state;
};

export const openQAModalReducer = (state = {}, action) => {
  if (action.type === OPEN_QA_MODAL) {
    return action.payload;
  }
  return state;
};

export const sessionPolls = (state = {}, action) => {
  if (action.type === SESSION_POLL_LIST) {
    return action.payload;
  }
  return state;
};

export const sessionPollsListModal = (state = {}, action) => {
  if (action.type === SESSION_POLL_LIST_MODAL) {
    return action.payload;
  }
  return state;
};

export const sessionPollsActionModal = (state = {}, action) => {
  if (action.type === SESSION_POLL_ACTION_MODAL) {
    return action.payload;
  }
  return state;
};

export const sessionPollsResult = (state = {}, action) => {
  if (action.type === SESSION_POLL_RESULT) {
    return action.payload;
  }
  return state;
};

export const myBookedSchedule = (state = {}, action) => {
  if (action.type === MY_BOOKED_SCHEDULE) {
    return action.payload;
  }
  return state;
};

export const myRatedSessionReducer = (state = {}, action) => {
  if (action.type == MY_RATED_SESSION) {
    return action.payload;
  }
  return state;
};

export const holdThisSessionDetailsReducer = (state = {}, action) => {
  if (action.type == HOLD_THIS_SESSION_DETAILS) {
    return action.payload;
  }
  return state;
};

export const liveQAReplyReducer = (state = {}, action) => {
  if (action.type == FETCH_LIVEQA_REPLY) {
    return action.payload;
  }
  return state;
};

export const sessionVideoModalDetails = (state = {}, action) => {
  if (action.type == SESSION_VIDEO_MODAL_DETAILS) {
    return action.payload;
  }
  return state;
};

export const sessionRatingFormDataReducer = (state = {}, action) => {
  if (action.type == THIS_SESSION_RATING_FORM) return action.payload;
  return state;
};

export const notSubmittedPollCountReducer = (state = { count: 0 }, action) => {
  if (action.type == SESSION_POLL_NOT_SUBMITTED) return action.payload;
  return state;
};

export const sessionsFilteredByTagsReducer = (state = {}, action) => {
  if (action.type == SESSION_BY_TAG_FILTERED) return action.payload;
  return state;
};

export const sessionColorsReducer = (state = {}, action) => {
  if (action.type == SESSION_COLORS) return action.payload;
  return state;
};

export const allEventTrackReducer = (state = [], action) => {
  if (action.type === ALL_EVENT_TRACKS) return action.payload;
  return state;
};

export const sessionFilterData = (state = {}, action) => {
  if (action.type === SESSION_FILTER_DATA) return action.payload;
  return state;
};

export const overlappingSessionsForAllTracks = (state = {}, action) => {
  if (action.type === SESSIONS_FOR_ALL_TRACKS) return action.payload;
  return state;
};
